export enum PossibleListTypesEnum {
  Contact = 'contacts',
  JobAds = 'jobads'
}
